import { createBrowserRouter, Navigate, Outlet } from 'react-router';
import { AuthGuard } from '@/components/auth/AuthGuard';
import { AppShell } from '@/components/layout/AppShell';
import { AuthLayout } from './auth/AuthLayout';
import ForgotPage from './auth/forgot';
import LoginPage from './auth/login';
import ResetPage from './auth/reset';
import SignupPage from './auth/signup';
import CertificatesPage from './certificates';
import OnboardingPage from './onboarding';
import ServicesPage from './services';
import SettingsPage from './settings';
import CalendarPage from './calendar';
import FiscalMonthPage from './fiscal';
import FiscalRecordPage from './fiscal/$recordId';
import AccountantPage from './accountant';
import InboxPage from './inbox';
import PublicAccountantPage from './contador/$token';
import ShiftPage from './shift/$shiftId';
import ActiveShiftsPage from './shifts';
import SummaryPage from './summary';

function PrivateLayout() {
  return (
    <AuthGuard>
      <AppShell>
        <Outlet />
      </AppShell>
    </AuthGuard>
  );
}

export const router = createBrowserRouter([
  {
    element: <AuthLayout />,
    children: [
      { path: '/login', element: <LoginPage /> },
      { path: '/signup', element: <SignupPage /> },
      { path: '/forgot', element: <ForgotPage /> },
      { path: '/reset', element: <ResetPage /> },
    ],
  },
  { path: '/contador/:token', element: <PublicAccountantPage /> },
  {
    path: '/onboarding',
    element: (
      <AuthGuard allowUnboarded>
        <OnboardingPage />
      </AuthGuard>
    ),
  },
  {
    path: '/',
    element: <PrivateLayout />,
    children: [
      { index: true, element: <Navigate to="/calendar" replace /> },
      {
        path: 'calendar',
        element: <CalendarPage />,
      },
      {
        path: 'shifts',
        element: <ActiveShiftsPage />,
      },
      {
        path: 'shift/:shiftId',
        element: <ShiftPage />,
      },
      {
        path: 'fiscal',
        element: <FiscalMonthPage />,
      },
      {
        path: 'fiscal/:recordId',
        element: <FiscalRecordPage />,
      },
      {
        path: 'inbox',
        element: <InboxPage />,
      },
      {
        path: 'accountant',
        element: <AccountantPage />,
      },
      {
        path: 'summary',
        element: <SummaryPage />,
      },
      {
        path: 'services',
        element: <ServicesPage />,
      },
      {
        path: 'certificates',
        element: <CertificatesPage />,
      },
      {
        path: 'settings',
        element: <SettingsPage />,
      },
    ],
  },
  { path: '*', element: <Navigate to="/calendar" replace /> },
]);
